import { useMemo } from 'react';
import { Goal } from 'shared/types/goal';
import { GroupByMode, TaskGroupBy } from 'shared/types/sorting-mode';
import { noGroupingId } from 'shared/views/task-filter-list';

export const useAllTasksCustomOrderByGrouping = (
  groupBy: TaskGroupBy | undefined | null,
  goal?: Goal,
) =>
  useMemo(() => {
    if (!goal?.id) {
      return {};
    }
    const _groupBy = (
      [GroupByMode.None, GroupByMode.LifeArea].includes(groupBy!)
        ? GroupByMode.Section
        : groupBy ?? GroupByMode.Section
    ) as Exclude<GroupByMode, GroupByMode.None | GroupByMode.LifeArea>;
    if (_groupBy === GroupByMode.Section) {
      const goalSections = goal.sections ?? [];
      return {
        [noGroupingId]: goal.taskSorting ?? [],
        ...goalSections.reduce(
          (acc, section) => {
            acc[section.id] = section.tasks ?? [];
            return acc;
          },
          {} as Record<string, string[]>,
        ),
      };
    }

    return goal.customTaskOrder?.[_groupBy] ?? {};
  }, [
    goal?.customTaskOrder,
    goal?.id,
    goal?.sections,
    goal?.taskSorting,
    groupBy,
  ]);
